import axios from 'axios';
import { ContentType, HttpHeader } from '../constants/http';
import { origin } from './interceptors/request.origin';
import { authorize } from './interceptors/request.authorization';
import { refresh } from './interceptors/response.refresh';

const headers = {
	[HttpHeader['Content-Type']]: ContentType['application/x-www-form-urlencoded'],
	[HttpHeader['Check-Origin']]: 'popup'
};

export const client = axios.create({
	headers
});

client.interceptors.request.use(origin);
client.interceptors.request.use(authorize);
client.interceptors.response.use(refresh.onFulfilled, refresh.onRejected);
